import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import API from "../../../util/api";
import {
  actionContainerStyles,
  actionLinkStyles,
  actionHeaderStyles,
} from "../common/ActionStyles";
import ResponsiveActions from "../common/ResponsiveActions";

const LINK_HOVER_COLOR = "#F7941D";

const breakpoints = {
  tablet: 768,
  phone: 480,
};

const Actions = styled.div`
  ${actionContainerStyles};
  // border: 1px solid ${({ colors }) => colors.border};

  h3 {
    ${actionHeaderStyles};
    border-bottom: 1px solid ${({ colors }) => colors.border};
  }

  ul {
    margin: 0;
    padding: 12px 16px;
    list-style: none;
  }

  li + li {
    margin-top: 4px;
  }

  a,
  button {
    ${actionLinkStyles};
    padding-left: 16px;
    background: none;
    border: none;
    text-align: left;
    color: #2c4960;

    &:hover {
      color: ${LINK_HOVER_COLOR};
    }
  }
  @media (min-width: ${breakpoints.tablet}px) {
    flex: 0 0 260px;
  }
`;

export default function SchoolDistrictActionsLink({
  colors,
  onImport,
  onList,
  onUploads,
  onMerge,
}) {
  const subscription = useSelector((s) => s.auth.selected_subscriptions) || {};
  const invoiceId = subscription.invoice_id;
  const customerId = subscription.customer_id;

  const handleExport = async () => {
    try {
      const resp = await API.exportSchoolsList({
        invoice_id: invoiceId,
        customer_id: customerId,
      });
      // assume resp.file is a URL string
      const link = document.createElement("a");
      link.href = resp.file;
      // try to extract filename from URL or default
      const filename = resp.file.split("/").pop() || "schools_export.csv";
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Export failed:", err);
      // optionally show a toast or modal here
    }
  };

  return (
    <ResponsiveActions
      colors={colors}
      renderActions={() => (
        <Actions colors={colors}>
          <h3>Actions</h3>
          <ul>
            <li>
              <a onClick={onList}>List Schools/Districts</a>
            </li>
            <li>
              <a onClick={onImport}>Import Schools/Districts</a>
            </li>
            <li>
              <a onClick={onUploads}>Uploads</a>
            </li>
            <li>
              <a onClick={onMerge}>Merge Schools/Districts</a>
            </li>
            <li>
              <a href="/admincentral/resources/download/2">
                Download Blank Template
              </a>
            </li>
            <li>
              <button onClick={handleExport}>Export</button>
            </li>
          </ul>
        </Actions>
      )}
    />
  );
}
